/**
 * Created by luka on 01.03.2018.
 */

// sync this number with backend constants.js -> appVersion.web
export const APP_VERSION_NAME = "6.6";
export const APP_VERSION_CODE = 66;


// WEBPACK FOOTER //
// ./src/utils/version.js